export default {"src":"/_next/static/media/tools-illu.d1866c88.svg","height":89,"width":76,"blurWidth":0,"blurHeight":0};